import { render, staticRenderFns } from "./NewsRead.vue?vue&type=template&id=4a0e1401&"
import script from "./NewsRead.vue?vue&type=script&lang=js&"
export * from "./NewsRead.vue?vue&type=script&lang=js&"
import style0 from "./NewsRead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
